import { cn } from '@tempo-io/sui-class-utils';
import type { ReactNode } from 'react';
import { useFieldDisplay } from './FieldDisplayContext';

export const Field = ({
  inputId,
  name,
  children,
  statusIndicator,
  action,
  className,
}: {
  inputId?: string;
  name: string;
  children: ReactNode;
  statusIndicator?: ReactNode;
  action?: ReactNode;
  className?: string;
}) => {
  const { hideLabel } = useFieldDisplay();

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {(!hideLabel || action) && (
        <div className="flex items-center gap-2">
          {!hideLabel && (
            <>
              <label
                htmlFor={inputId}
                className="text-sm font-medium text-text-neutral-primary leading-none tracking-normal"
              >
                {name}
              </label>
              {statusIndicator}
            </>
          )}
          {action && <div className="ml-auto">{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
};
